<template>
    <div class="sub-tit">
        <h2>{{ menuName }}</h2>
    </div>
</template>


<script>
export default {
    props: {
        menuList: Array
    },
    data() {
        return {
            menuName:'',
        };
    },
    watch: {
        menuList(val){
            this.menuName = this.$commonUtils.getMenuName(val)
        }
    },
    mounted() {
        this.menuName = this.$commonUtils.getMenuName(this.menuList)
    }
}
</script>
